module.exports = __webpack_public_path__ + "static/media/recorridoKids.c62a674a.webp";